export const breakOffersToLines = <T>(input: T[]) => {
	const inputClone = [...input]

	const lines: T[][] = []

	while (inputClone.length > 0) {
		if (inputClone.length <= 3) {
			lines.push(inputClone)
			break
		}
		const remainder = inputClone.length % 4
		const isMultipleOf4 = remainder === 0

		if (isMultipleOf4) {
			const nIterations = inputClone.length / 4
			// break input in groups of 4 and append them to lines
			for (let i = 0; i < nIterations; i++) {
				lines.push(inputClone.splice(0, 4))
			}
			break
		} else {
			// put the 3 first and append then as an array to lines, then loop again
			lines.push(inputClone.splice(0, 3))
		}
	}

	return lines
}
